import Shell from "@/pages/Shell";
import { Seo } from "@/components/Seo";
import { Blog } from "@/components/Blog";

export default function BlogPage() {
  return (
    <Shell>
      <Seo
        title="Journal & Reflections — Charles McKuhn"
        description="Writing on faith, revival, leadership, and legacy by Charles McKuhn — published to inform, encourage, and build up the body of Christ."
        path="/blog"
      />
      <h1 className="sr-only">Journal & Reflections — Charles McKuhn</h1>
      <Blog />
    </Shell>
  );
}
